<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Persona Choice"
    seFeDataSubtitle="Used in the Persona Picker as a choice for a persona to select."
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <div class="docs-content">
      <se-fe-card>
        <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
        <se-fe-card-content>
          <p>Use this component when a set of personas should be listed and selectable</p>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card>
        <se-fe-card-header seFeDataTitle="PersonaChoiceComponent"></se-fe-card-header>
        <se-fe-card-content>
          <se-fe-docs-table
            [seFeDataHeaders]="headers"
            [seFeDataRows]="personaChoiceComponent">
          </se-fe-docs-table>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card>
        <se-fe-card-header seFeDataTitle="Persona Choice Example"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-persona-choice-example></se-po-persona-choice-example>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card>
        <se-fe-card-header seFeDataTitle="Persona Choice Example with Default Required Fields"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-persona-choice-example-with-default-fields></se-po-persona-choice-example-with-default-fields>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card>
        <se-fe-card-header seFeDataTitle="Persona Choice Example with Required Fields"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-persona-choice-example-with-required-fields></se-po-persona-choice-example-with-required-fields>
        </se-fe-card-content>
      </se-fe-card>
    </div>
  </div>
</se-fe-page>
